const $ = require('jquery');
require('bootstrap');

class Tips {
  /**
   * @param {Storage} storage
   * @param {Localization} localization
   */
  constructor(storage, localization) {
    this._storage = storage;
    this._localization = localization;
    this._currentTip = 1;
    this._totalTips = 7;
    this._popoverContainer = $('.btn-tips-and-tricks');
    this._tipsDismissedKey = 'tips-dismissed';
    this._listenersSet = false;
    this.addListeners();
  }

  getRandomTip() {
    this._currentTip = Math.floor(Math.random() * this._totalTips + 1);
    return this._localization.translate(`tips-and-tricks.${this._currentTip}`);
  }

  getNextTip() {
    if (this._currentTip < this._totalTips) {
      this._currentTip += 1;
    } else {
      this._currentTip = 1;
    }

    return this._localization.translate(`tips-and-tricks.${this._currentTip}`);
  }

  getPreviousTip() {
    if (this._currentTip > 1) {
      this._currentTip -= 1;
    } else {
      this._currentTip = this._totalTips;
    }

    return this._localization.translate(`tips-and-tricks.${this._currentTip}`);
  }

  updateDataTranslationKeys() {
    let popover = this._popoverContainer.data('bs.popover');
    popover.config.content = this._localization.translate(`tips-and-tricks.${this._currentTip}`);
    popover.update();

    const popoverContent = $('.popover.show #tips-and-tricks-popover-content');
    popoverContent
      .data("translation-key", `tips-and-tricks.${this._currentTip}`)
      .attr("data-translation-key", `tips-and-tricks.${this._currentTip}`);


    const popoverShow = $('.popover.show');
    const previousBtn = popoverShow.find('#tips-and-tricks-previous');
    const nextBtn = popoverShow.find('#tips-and-tricks-next')
    previousBtn.text(this._localization.translate("general.previous"));
    nextBtn.text(this._localization.translate("general.next"));
  }

  addListeners() {
    this._popoverContainer.popover({
      trigger: 'click',
      html: true,
      placement: 'top',
      title: `${this._localization.translate('editor.tips-and-tricks')}<button type="button" id="close" class="close">&times;</button>`,
      content: this.getRandomTip(),
      template: $('#tips-and-tricks-popover-template').html(),
    });

    this._storage.getOption(this._tipsDismissedKey)
      .then((value) => {
        if (value !== true) {
          this._popoverContainer.popover('show');
        }
      });

    this._popoverContainer.on('shown.bs.popover', () => {
      this.updateDataTranslationKeys();

      // noinspection JSJQueryEfficiency
      $('.popover.show #tips-and-tricks-popover-header').find('#close').on('click', (event) => {
        event.preventDefault();
        this._storage.putOption(this._tipsDismissedKey, true);
        this._popoverContainer.popover('hide');
      });

      if (this._listenersSet === true) return;

      // noinspection JSJQueryEfficiency
      $('.popover.show').find('#tips-and-tricks-previous').on('click', (event) => {
        event.preventDefault();
        $('.popover.show').find('#tips-and-tricks-popover-content').html(this.getPreviousTip());
        this.updateDataTranslationKeys();
      });

      // noinspection JSJQueryEfficiency
      $('.popover.show').find('#tips-and-tricks-next').on('click', (event) => {
        event.preventDefault();
        $('.popover.show').find('#tips-and-tricks-popover-content').html(this.getNextTip());
        this.updateDataTranslationKeys();
      });

      this._listenersSet = true;
    });
  }
}

module.exports = Tips;
